(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[362],{

/***/ 77615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A2": function() { return /* binding */ approveFca; },
/* harmony export */   "N$": function() { return /* binding */ fetchFcaQueue; },
/* harmony export */   "Zx": function() { return /* binding */ saveFca; },
/* harmony export */   "aj": function() { return /* binding */ refreshProfile; },
/* harmony export */   "er": function() { return /* binding */ rejectFca; },
/* harmony export */   "kb": function() { return /* binding */ fetchFca; },
/* harmony export */   "nW": function() { return /* binding */ removeFca; },
/* harmony export */   "r0": function() { return /* binding */ recheckFca; },
/* harmony export */   "tb": function() { return /* binding */ fetchFcaCsv; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);
/* harmony import */ var store_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3383);




var unwrap = function(res) {
    return res.data.data;
};
var fetchFca = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(profileId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/profiles/".concat(profileId, "/fca"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchFca(profileId) {
        return _ref.apply(this, arguments);
    };
}();
var saveFca = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(profileId, details) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/profiles/".concat(profileId, "/fca"), details)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function saveFca(profileId, details) {
        return _ref.apply(this, arguments);
    };
}();
var removeFca = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(profileId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/profiles/".concat(profileId, "/fca"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function removeFca(profileId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchFcaQueue = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var _state, state, _page, page, _size, size;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state1) {
            switch(_state1.label){
                case 0:
                    _state = param.state, state = _state === void 0 ? "pending" : _state, _page = param.page, page = _page === void 0 ? 1 : _page, _size = param.size, size = _size === void 0 ? 20 : _size;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/fca/queue", {
                            params: {
                                state: state,
                                page: page,
                                size: size
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state1.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchFcaQueue(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchFcaCsv = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/fca/export", {
                            responseType: "blob"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function fetchFcaCsv() {
        return _ref.apply(this, arguments);
    };
}();
var approveFca = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(profileId, decision) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/profiles/".concat(profileId, "/fca/approve"), decision)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function approveFca(profileId, decision) {
        return _ref.apply(this, arguments);
    };
}();
var recheckFca = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(profileId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/profiles/".concat(profileId, "/fca/recheck"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function recheckFca(profileId) {
        return _ref.apply(this, arguments);
    };
}();
var rejectFca = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(profileId, decision) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/profiles/".concat(profileId, "/fca/reject"), decision)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function rejectFca(profileId, decision) {
        return _ref.apply(this, arguments);
    };
}();
// A failed refresh only delays the label change until the next page load.
var refreshProfile = function(dispatch, slug) {
    return (0,api__WEBPACK_IMPORTED_MODULE_0__/* .getReq */ .ZL)("/profiles/slug/".concat(slug)).then(function(param) {
        var data = param.data;
        var ref;
        if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.id) dispatch(store_company__WEBPACK_IMPORTED_MODULE_1__/* .fetchCompanyBySlug.fulfilled */ ._g.fulfilled(data.data));
    }).catch(function() {});
};


/***/ }),

/***/ 37665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BV": function() { return /* binding */ markReraw; },
/* harmony export */   "NB": function() { return /* binding */ unpublishStory; },
/* harmony export */   "NI": function() { return /* binding */ setAlertNoindex; },
/* harmony export */   "To": function() { return /* binding */ markNotRaw; },
/* harmony export */   "Ui": function() { return /* binding */ fetchAuthors; },
/* harmony export */   "W3": function() { return /* binding */ publishStory; },
/* harmony export */   "Xl": function() { return /* binding */ markRaw; },
/* harmony export */   "aL": function() { return /* binding */ fetchNews; },
/* harmony export */   "mY": function() { return /* binding */ saveStory; },
/* harmony export */   "q6": function() { return /* binding */ uploadLeadImage; },
/* harmony export */   "su": function() { return /* binding */ fetchStory; },
/* harmony export */   "tt": function() { return /* binding */ newsroomError; },
/* harmony export */   "yV": function() { return /* binding */ fetchRawQueue; }
/* harmony export */ });
/* unused harmony export fetchRaws */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);




// Storify / Raw / Publish and the Raws archive. These call the axios instance
// directly (not getReq/postReq) so the API's error message reaches the editor,
// e.g. "Write and save a headline and a story before publishing".
var unwrap = function(res) {
    return res.data.data;
};
var newsroomError = function(err, fallback) {
    var ref, ref1;
    var message = err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
    if (Array.isArray(message)) return message.join(" ");
    return typeof message === "string" && message ? message : fallback;
};
var fetchStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/alerts/".concat(alertId, "/story"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var saveStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, story) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/alerts/".concat(alertId, "/story"), story)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function saveStory(alertId, story) {
        return _ref.apply(this, arguments);
    };
}();
// Not fileUpload: its multipart interceptor stays on after a failed request. Axios sets
// the multipart header and boundary itself for FormData.
var formData = function(fields) {
    return Object.entries(fields).reduce(function(form, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        form.append(key, value);
        return form;
    }, new FormData());
};
var _leadImageAlt, _leadImageCaption, _leadImageCredit;
// The API checks the file and makes the 1200px copy and the crops; the story must be saved first.
var uploadLeadImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, file, draft) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/lead-image"), formData({
                            image: file,
                            leadImageAlt: (_leadImageAlt = draft.leadImageAlt) !== null && _leadImageAlt !== void 0 ? _leadImageAlt : "",
                            leadImageCaption: (_leadImageCaption = draft.leadImageCaption) !== null && _leadImageCaption !== void 0 ? _leadImageCaption : "",
                            leadImageCredit: (_leadImageCredit = draft.leadImageCredit) !== null && _leadImageCredit !== void 0 ? _leadImageCredit : ""
                        }))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function uploadLeadImage(alertId, file, draft) {
        return _ref.apply(this, arguments);
    };
}();
var publishStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/publish"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function publishStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var unpublishStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/unpublish"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function unpublishStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// Out of Google (noindex,follow, off the sitemaps) or back in; the page stays live either way.
var setAlertNoindex = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, noindex) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/alerts/".concat(alertId, "/noindex"), {
                            noindex: noindex
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function setAlertNoindex(alertId, noindex) {
        return _ref.apply(this, arguments);
    };
}();
var markRaw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        var exclusiveUntil;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    exclusiveUntil = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/raw"), {
                            exclusiveUntil: exclusiveUntil
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markRaw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// Back to the top of the Raws archive, without touching the alert's own dates.
var markReraw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/reraw"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markReraw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// "Not a Raw": out of the archive if it was in it, and out of the review queue.
var markNotRaw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/alerts/".concat(alertId, "/raw"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markNotRaw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchRaws = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, q, tag, _page, page, _size, size, params;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, q = ref.q, tag = ref.tag, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    params = {
                        page: page,
                        size: size
                    };
                    if (q) params.q = q;
                    if (tag) params.tags = tag;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raws", {
                            params: params
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchRaws() {
        return _ref.apply(this, arguments);
    };
}();
var fetchRawQueue = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raws/queue", {
                            params: {
                                page: page,
                                size: size
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchRawQueue() {
        return _ref.apply(this, arguments);
    };
}();
var fetchNews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size, profile, author;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size, profile = ref.profile, author = ref.author;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/news", {
                            params: {
                                page: page,
                                size: size,
                                profile: profile,
                                author: author
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchNews() {
        return _ref.apply(this, arguments);
    };
}();
var fetchAuthors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/authors")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchAuthors() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 53926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"Fca_section__DCs2X","decision":"Fca_decision__KW3ao","panel":"Fca_panel__me7HT","filters":"Fca_filters__9DpF1","form":"Fca_form__1hSkR","intro":"Fca_intro__GD2C1","hint":"Fca_hint__X51Xa","field":"Fca_field__Wdos1","livePreview":"Fca_livePreview__fQT3R","livePreviewTitle":"Fca_livePreviewTitle__qnPuT","introEditor":"Fca_introEditor__nAMLP","choices":"Fca_choices__jgW8_","fieldError":"Fca_fieldError__9lRXU","error":"Fca_error__n_jcz","spaced":"Fca_spaced__UI85f","status":"Fca_status__pjQjD","statusRejected":"Fca_statusRejected__ZE3Lq","banner":"Fca_banner__uqdhB","anchored":"Fca_anchored__LMhvm","saved":"Fca_saved__ZmT0Z","actions":"Fca_actions__P8uwO","textButton":"Fca_textButton__CO_8j","facts":"Fca_facts__4Bx_w","links":"Fca_links__q4xg6","badge":"Fca_badge__s7jjn","badgePending":"Fca_badgePending__eF1X8","badgeApproved":"Fca_badgeApproved__O5u4N","badgeRejected":"Fca_badgeRejected__yH9Dt","decisionForm":"Fca_decisionForm__V3QWv","queueIntro":"Fca_queueIntro__bzEky"};

/***/ })

}]);